import { useSelector } from "react-redux";

export const useCheckField = () => {
    const range = useSelector(state => state.timetable.intersectionCheck.range);
    const role = useSelector(state => state.timetable.intersectionCheck.role);

    return (range.start && range.end && role)
}